/** @prettier */

import {
  useLocation,
  Outlet,
  Navigate,
  useOutletContext,
} from 'react-router-dom';

//interface import
import * as apiIF from '../../Type/api';

import {useUserState} from '../Root';
import {routeList} from '../PrivateRoute';

//カスタムフック
type ContextType = {
  email: string;
  userInfo: apiIF.res.getSettingUser | null;
};
export function useUserInfo() {
  return useOutletContext() as ContextType;
}

/**
 * マイサイトのメインの画面、ポップアップ画面
 * @returns
 */
export const MainMySite = () => {
  const {isAuthenticated, email, userInfo} = useUserState();
  let location = useLocation();

  return (
    <>
      {/* 認証の状態で画面を切り替える */}
      {isAuthenticated ? (
        <Outlet context={{email, userInfo}} />
      ) : (
        <Navigate
          to={routeList.login.path}
          state={{from: location.pathname}}
          replace={true}
        />
      )}
    </>
  );
};
export default MainMySite;
